import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["latitude", "longitude"]

    declare readonly latitudeTarget: HTMLInputElement
    declare readonly longitudeTarget: HTMLInputElement

    paste(event: ClipboardEvent) {
        const clipboardData = event.clipboardData
        if (!clipboardData) return

        const pastedText = clipboardData.getData("text")
        if (!pastedText) return

        // Prüfen, ob der Text ein Komma oder Semikolon enthält (häufige Trenner für Koordinaten)
        const parts = pastedText.split(/[,\s]+/).map(part => part.trim()).filter(part => part.length > 0)

        if (parts.length >= 2) {
            const lat = Number(parseFloat(parts[0]).toFixed(6))
            const lng = Number(parseFloat(parts[1]).toFixed(6))

            if (!isNaN(lat) && !isNaN(lng)) {
                event.preventDefault()
                this.latitudeTarget.value = lat.toString()
                this.longitudeTarget.value = lng.toString()

                // Trigger input events so any listeners (like auto-save) are notified
                this.latitudeTarget.dispatchEvent(new Event("input", {bubbles: true}))
                this.longitudeTarget.dispatchEvent(new Event("input", {bubbles: true}))
            }
        }
    }
}
